import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { FormatListBulleted } from '@styled-icons/material/FormatListBulleted';
import { FormatListNumbered } from '@styled-icons/material/FormatListNumbered';
import { ELEMENT_OL, ELEMENT_UL, getPluginType, ListToolbarButton, } from '@udecode/plate';
import { useMyPlateEditorRef } from '../typescript/plateTypes';
const ListToolbarButtons = () => {
    const editor = useMyPlateEditorRef();
    return (_jsxs(_Fragment, { children: [_jsx(ListToolbarButton, { type: getPluginType(editor, ELEMENT_UL), icon: _jsx(FormatListBulleted, {}) }), _jsx(ListToolbarButton, { type: getPluginType(editor, ELEMENT_OL), icon: _jsx(FormatListNumbered, {}) })] }));
};
export default ListToolbarButtons;
//# sourceMappingURL=ListToolbarButtons.js.map